import { theme } from '~/shared/styles/theme';

const CheckmarkCircleEmpty = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="22.5"
        cy="22.5"
        r="21.5"
        stroke={theme.palette.custom.lightGrayBrown}
        strokeWidth="2"
      />
    </svg>
  );
};

export default CheckmarkCircleEmpty;
